import SharedDialog from '../../../../../../global/Modal/Modal';
import { SaveScoreModalProps } from '../types';

export function SaveScoreModal({
  isOpen,
  onClose,
  onConfirm,
  scoreName,
  setScoreName,
  sourceWeights,
  view,
  tab,
  isSaving,
}: SaveScoreModalProps) {
  return (
    <SharedDialog
      isOpen={isOpen}
      onClose={onClose}
      title="Save Score Weights"
      description="Give your custom score weights a name to save them for later use."
      confirmText={isSaving ? 'Saving...' : 'Save'}
      cancelText="Cancel"
      onConfirm={onConfirm}
      hasConfirmBtn
    >
      <div className="mt-4">
        <div className="mb-3">
          <label htmlFor="scoreName" className="form-label font-medium">
            Score Name:
          </label>
          <input
            id="scoreName"
            type="text"
            className="form-control"
            value={scoreName}
            onChange={e => setScoreName(e.target.value)}
            placeholder="Enter a name for this score configuration"
            maxLength={100}
            disabled={isSaving}
          />
          {!scoreName.trim() && <small className="text-danger">Please enter a name for the score</small>}
        </div>

        {sourceWeights && sourceWeights.length > 0 && (
          <div className="mt-3">
            <h6 className="font-medium mb-2">Score Details:</h6>
            <div className="bg-light p-3 rounded">
              <div className="mb-2">
                <small className="text-muted">View:</small> <strong>{view}</strong>
                <br />
                <small className="text-muted">Tab:</small> <strong>{tab}</strong>
              </div>
              <div className="mt-2">
                <small className="text-muted">Source Weights:</small>
                <br />
                {sourceWeights.map((sw, idx) => (
                  <div key={idx} className="mt-1">
                    <small>
                      <strong>{sw.name.replace('_', ' ')}</strong>: {sw.score.toFixed(2)}
                    </small>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </SharedDialog>
  );
}
